(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["os-catalog-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('os-filtered-catalog')) {
    customElements.define('os-filtered-catalog', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
        } else {
          this.initialize();
        }
      }

      initialize() {
        if (this.initialized) return;
        const controls = this.querySelector('.catalog-filters');
        const cards = Array.from(this.querySelectorAll('.product-grid > .product-card'));
        const buttons = Array.from(this.querySelectorAll('[data-catalog-filter]'));
        const status = this.querySelector('[data-catalog-status]');
        if (!controls || !cards.length || !status) return;
        this.initialized = true;
        const applyFilter = (selected, announce = false) => {
          const category = selected.dataset.catalogFilter;
          let shown = 0;
          cards.forEach(card => {
            const matches = category === 'all' || (card.dataset.catalogCollections || '').split(' ').includes(category);
            card.hidden = !matches;
            if (matches) shown += 1;
          });
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
          if (announce) status.textContent = this.dataset.countLabel.replace('[count]', String(shown));
        };
        controls.addEventListener('click', event => {
          const selected = event.target.closest('[data-catalog-filter]');
          if (selected && controls.contains(selected)) applyFilter(selected, true);
        });
        const initial = buttons.find(button => button.dataset.catalogFilter === this.dataset.initialFilter) || buttons[0];
        applyFilter(initial);
        controls.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
